import { getPackageBaseUrl } from 'owa-config';
import { urlResolve } from 'mini-common-utils/lib/utils/urlResolve';

const BASE_PATH_WARM_WELCOME = 'resources/campaign/warmWelcome';

/**
 * Warm welcome video src
 */
export const WARM_WELCOME_VIDEO_SRC = [
    {
        src: urlResolve(getPackageBaseUrl(), BASE_PATH_WARM_WELCOME + '.webm'),
        type: 'video/webm',
    },
    {
        src: urlResolve(getPackageBaseUrl(), BASE_PATH_WARM_WELCOME + '.mp4'),
        type: 'video/mp4',
    },
];

/**
 * Warm welcome image src
 */
export const WARM_WELCOME_IMAGE_SRC = urlResolve(
    getPackageBaseUrl(),
    BASE_PATH_WARM_WELCOME + '.svg'
);
